import BookingWizard from "@/components/BookingWizard";
import { Card } from "@/components/ui/card";
import { Music, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PublicBookingPage() {
    return (
        <div className="min-h-screen bg-[hsl(var(--paper))]">
            <header className="border-b border-border bg-background/70 backdrop-blur">
                <div className="max-w-5xl mx-auto flex items-center justify-between px-6 py-3">
                    <Link to="/" className="flex items-center gap-2">
                        <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center text-primary-foreground"><Music className="h-5 w-5" strokeWidth={1.75} /></div>
                        <div className="font-display text-lg font-semibold tracking-tight">Musook</div>
                    </Link>
                    <Button asChild variant="outline"><Link to="/chat"><Sparkles className="mr-2 h-4 w-4" />Prefer to chat?</Link></Button>
                </div>
            </header>
            <div className="max-w-3xl mx-auto p-6">
                <div className="mb-6">
                    <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight">Book a session at Musook</h1>
                    <p className="text-muted-foreground mt-1">Answer a few questions and we’ll take care of the rest.</p>
                </div>
                <Card className="p-6 border-border">
                    <BookingWizard onSuccess={() => {}} onCancel={() => {}} />
                </Card>
            </div>
        </div>
    );
}